export const photos = {
  crowdDay:
    'https://cdn.magicpatterns.com/uploads/tzJVBNQUYJxYG751TWtjoZ/299662472_477051561093280_2803671010935758755_n-133611.jpg',
  crowdNight:
    'https://cdn.magicpatterns.com/uploads/85jgurbeAyc1kZybefdSMb/306516763_498419235623179_5545307017926075766_n-133611.jpg',
  julien:
    'https://cdn.magicpatterns.com/uploads/tJUTeztuL6rhYVLgNcsAHJ/julien-bonnemain-chanteur--133611.jpg',
};

export const youtubeId = '_Z9yLC29mDE';
export const youtubeStart = 24;

export const navLinks = [
  { label: 'Accueil', to: '/' },
  { label: 'Le groupe', to: '/groupe' },
  { label: 'Formules', to: '/formules' },
  { label: 'Concerts', to: '/concerts' },
  { label: 'Médias', to: '/medias' },
  { label: 'Organisateurs', to: '/organisateurs' },
];

export const songs = [
  'Un autre monde',
  'Ça (c’est vraiment toi)',
  'New York avec toi',
  'La bombe humaine',
  'Argent trop cher',
  'Cendrillon',
  'Hygiaphone',
  'Le jour s’est levé',
  'Dures à cuire',
  'Crache ton venin',
  'Fait divers',
  'Electric Cité',
];

export const members = [
  { name: 'Julien Bonnemain', role: 'Chant & guitare', lead: true },
  { name: 'Morgan Denys', role: 'Musicien', lead: false },
  { name: 'Jeremy Gilson', role: 'Musicien', lead: false },
  { name: 'Maximum Ravello', role: 'Musicien', lead: false },
];

export const facts = [
  { value: '2012', label: 'Création du groupe' },
  { value: '1h30', label: 'De show, jusqu’au dernier rappel' },
  { value: 'France', label: 'Tournée dans tout le pays' },
];

export const formulas = [
  {
    name: 'Tribute Téléphone',
    tagline: 'La formule historique',
    description:
      'Les grands titres de Téléphone joués avec l’urgence et l’électricité d’origine. Un show calibré jusqu’à 1h30 pour faire chanter toutes les générations.',
    details: ['Jusqu’à 1h30 de concert', 'Les tubes de 1976 à 1986', 'Plein air ou salle'],
  },
  {
    name: 'Formule Jean-Louis Aubert',
    tagline: 'L’autre voix du rock français',
    description:
      'Une formule dédiée au répertoire de Jean-Louis Aubert, pour prolonger l’histoire au-delà de Téléphone.',
    details: ['Répertoire Jean-Louis Aubert', 'Format adaptable'],
  },
];

export const audiences = [
  {
    title: 'Festivals',
    description: 'Une tête d’affiche fédératrice qui fait lever la foule dès le premier riff.',
  },
  {
    title: 'Événements municipaux',
    description: 'Fête de la musique, 14 juillet, fêtes de village : un répertoire que tout le monde connaît.',
  },
  {
    title: 'Salles de spectacles',
    description: 'Un concert complet jusqu’à 1h30, rodé sur plus de 200 dates.',
  },
  {
    title: 'Événements privés',
    description: 'Soirées d’entreprise, anniversaires, mariages : le rock français comme moment fort.',
  },
];
